import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { ThemeProvider, useTheme } from "@/components/ThemeContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import HomePage from "@/pages/HomePage";
import ChiSiamoPage from "@/pages/ChiSiamoPage";
import ServiziPage from "@/pages/ServiziPage";
import PrenotazionePage from "@/pages/PrenotazionePage";
import ContattiPage from "@/pages/ContattiPage";
import CookieBanner from "@/components/CookieBanner";
import { Toaster } from "@/components/ui/sonner";

function AppInner() {
  const { isDark } = useTheme();
  return (
    <div className={`App min-h-screen transition-colors duration-500 ${isDark ? "bg-[#0A0A0A] text-white" : "bg-[#F5F0E8] text-[#1A1A1A]"}`}>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/chi-siamo" element={<ChiSiamoPage />} />
          <Route path="/servizi" element={<ServiziPage />} />
          <Route path="/prenota" element={<PrenotazionePage />} />
          <Route path="/contatti" element={<ContattiPage />} />
        </Routes>
        <Footer />
        <StickyMobileCTA />
        <CookieBanner />
        <Toaster position="top-right" theme={isDark ? "dark" : "light"} />
      </BrowserRouter>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppInner />
    </ThemeProvider>
  );
}

export default App;
